import { z } from "zod";
import { AddressModelSchema } from "./AddressModel";

export const AddressBreakdownModelSchema = z.object({
  line1: z.string(),
  line2: z.string().optional(),
  line3: z.string().optional(),
  postCode: z.string().optional(),
  country: z.string().optional(),
  inValid: z.boolean(),
});

export const IfcsDetailsModelSchema = z.object({
  physicalAddress: AddressModelSchema.optional().nullable(),
  postalAddress: AddressModelSchema.optional().nullable(),
  isValid: z.boolean(),
});
